var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvoicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_930_6371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1191 13.8888H11.9408V13.6213H12.0077C12.0746 13.6213 12.1191 13.6213 12.186 13.6436C12.2306 13.6659 12.2529 13.7105 12.2529 13.7551C12.2752 13.822 12.2083 13.8888 12.1191 13.8888ZM12.4313 13.7328C12.4313 13.6436 12.3867 13.5767 12.3198 13.5098C12.2306 13.4652 12.1414 13.4429 12.0523 13.4429H11.7624V14.3348H11.9408V14.0003H12.0969L12.2752 14.3348H12.4759L12.2752 13.978C12.3644 13.978 12.4536 13.8666 12.4313 13.7328ZM12.0969 14.6246C11.7178 14.6246 11.4057 14.3125 11.4057 13.9334C11.4057 13.5544 11.7178 13.2423 12.0969 13.2423C12.4759 13.2423 12.788 13.5544 12.788 13.9334C12.788 14.3125 12.4759 14.6246 12.0969 14.6246ZM12.0969 13.0862C11.6286 13.0862 11.2273 13.4652 11.2273 13.9557C11.2273 14.4463 11.6063 14.8253 12.0969 14.8253C12.5651 14.8253 12.9664 14.4463 12.9664 13.9557C12.9664 13.4652 12.5651 13.0862 12.0969 13.0862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02234 1.82644C7.14715 -0.380887 12.4537 1.93792 12.855 7.53429C5.20738 8.15859 4.29323 4.70267 3.02234 1.82644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02234 13.8442C7.14715 16.0516 12.4537 13.7327 12.855 8.13638C5.20738 7.51208 4.29323 10.968 3.02234 13.8442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.428 3.58787C9.44363 1.0015 5.85392 0.26572 3 1.84876C4.13711 4.43513 5.00667 7.44512 10.6476 7.62349C11.3388 6.3972 11.6064 4.99254 11.428 3.58787ZM4.38237 10.9902C4.53844 10.9902 4.71681 11.0125 4.87289 11.0125C7.08022 11.0125 9.15377 9.92001 10.3578 8.06942C6.99103 8.24779 5.3857 9.47409 4.38237 10.9902Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_930_6371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvoicon);
export default __webpack_public_path__ + "static/media/evoicon.35bd036987b6c8eb2da6aee963f2ee71.svg";
export { ForwardRef as ReactComponent };